import apiClient from "./api-client";
import i18n from "../i18n";

type Assessment = Pick<Awaited<ReturnType<typeof apiClient.assessment.getCourseAssessments>>[number], "quizInfo">;

export function removeAssessmentNameSuffix(nameWithSuffix: string, suffix?: string) {
	return nameWithSuffix.replace(suffix ? ` (${suffix})` : "", "").replace(` (YuJa Verity for Test Proctoring)`, "");
}

export function extractAssessmentName(
	assessment?: Assessment,
	suffix?: string,
	removeSuffix = true,
	unknownName = i18n.t("helpers.assessmentNameTS.notFound") as string,
) {
	const name =
		((assessment?.quizInfo as
			| {
					name?: string;
			  }
			| undefined) ?? {})["name"]?.toString() ?? unknownName;
	return removeSuffix ? removeAssessmentNameSuffix(name, suffix) : name;
}

export function isPortalCreatedThirdPartyAssessment(assessment: Assessment) {
	return extractAssessmentName(assessment).startsWith("Third Party: ");
}
